  // Open mega menu on hover for desktop
    if (window.innerWidth > 992) {
        document.querySelector('.mega-trigger')
            .addEventListener('mouseover', () => {
                document.querySelector('.mega-trigger').classList.add('show');
            });

        document.querySelector('.mega-trigger')
            .addEventListener('mouseleave', () => {
                document.querySelector('.mega-trigger').classList.remove('show');
            });
    }

document.querySelectorAll('.nav-item.dropdown').forEach(function (item) {

    const link = item.querySelector('.nav-link.dropdown-toggle');
    const arrow = link.querySelector('.menu-arrow');
    const menu = item.querySelector('.dropdown-menu');

    const dropdown = new bootstrap.Dropdown(link, {
        autoClose: true
    });

    // Arrow click -> open dropdown
    arrow.addEventListener('click', function (e) {

        e.preventDefault();
        e.stopPropagation();

        dropdown.toggle();
    });

    // Text click -> go to page
    link.addEventListener('click', function (e) {

        if (e.target.closest('.menu-arrow')) return;

        const url = this.getAttribute('href');

        if (url && url !== '#') {
            window.location.href = url;
        }
    });

});

document.querySelectorAll('.dropdown-submenu').forEach(function (submenu) {

    const link = submenu.querySelector('.dropdown-toggle');
    const arrow = link.querySelector('.menu-arrow');
    const menu = submenu.querySelector('.dropdown-menu');

    // Arrow click -> open/close submenu
    arrow.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        menu.classList.toggle('show');
    });

    // Text click -> navigate
    link.addEventListener('click', function (e) {

        if (e.target.closest('.menu-arrow')) return;

        const url = this.getAttribute('href');

        if (url && url !== '#') {
            window.location.href = url;
        }
    });

});

const searchToggle = document.querySelector('.aq-search-toggle-new');
const searchWrapper = document.querySelector('.search-wrapper');

searchToggle.addEventListener('click', () => {
    searchWrapper.classList.toggle('active');
});

